import React from "react";
import { cx } from "../../utils";

const textVariants = {
  eyebrow: "text-eyebrow font-extrabold tracking-eyebrow text-accent",
  date: "text-eyebrow font-extrabold uppercase tracking-[.16em] text-date",
  sectionNumber: "whitespace-nowrap text-[9px] font-extrabold tracking-eyebrow text-subtle max-[640px]:text-[8px]",
};
export function Text({ variant, className, ...props }: React.HTMLAttributes<HTMLSpanElement> & {
  variant: keyof typeof textVariants;
}) {
  return <span className={cx(textVariants[variant], className)} {...props} />;
}

export function Heading({ className, children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cx("mt-[7px] font-heading text-[clamp(30px,3.5vw,43px)] font-black leading-none tracking-[.02em] max-[640px]:text-[34px]", className)} {...props}>{children}</h2>;
}
